import { render, staticRenderFns } from "./delivery-error-modal.component.vue?vue&type=template&id=3c848ee4&"
import script from "./delivery-error-modal.component.vue?vue&type=script&lang=ts&"
export * from "./delivery-error-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./delivery-error-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "delivery-error-modal.component.vue"
export default component.exports